import { render, staticRenderFns } from "./VentasInstante.vue?vue&type=template&id=bbe56dfc&"
import script from "./VentasInstante.vue?vue&type=script&lang=js&"
export * from "./VentasInstante.vue?vue&type=script&lang=js&"
import style0 from "./VentasInstante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports